import { CommonModule } from '@angular/common';
import { TemplateRef, Component, ChangeDetectionStrategy, Input, NgModule, Directive, ViewContainerRef, ɵɵdefineInjectable, Injectable, ɵɵinject, ComponentFactoryResolver, INJECTOR, ApplicationRef, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function DynamicContentComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicContentComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicContentComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DynamicContentComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.content)("ngTemplateOutletContext", ctx_r1.context);
} }
function DynamicContentComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicContentComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DynamicContentComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngComponentOutlet", ctx_r2.content)("ngComponentOutletInjector", ctx_r2.injector);
} }
var ContentType;
(function (ContentType) {
    ContentType[ContentType["String"] = 0] = "String";
    ContentType[ContentType["Template"] = 1] = "Template";
    ContentType[ContentType["Component"] = 2] = "Component";
})(ContentType || (ContentType = {}));
class DynamicContentComponent {
    constructor() {
        this.ContentType = ContentType;
        this.contentType = ContentType.String;
    }
    set content(contentType) {
        this._content = contentType;
        this.resolveContentType();
    }
    get content() {
        return this._content;
    }
    resolveContentType() {
        if (typeof this.content === 'string') {
            this.contentType = ContentType.String;
        }
        else if (this.content instanceof TemplateRef) {
            this.contentType = ContentType.Template;
        }
        else {
            this.contentType = ContentType.Component;
        }
    }
}
DynamicContentComponent.ɵfac = function DynamicContentComponent_Factory(t) { return new (t || DynamicContentComponent)(); };
DynamicContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicContentComponent, selectors: [["dynamic-content"]], inputs: { content: "content", context: "context", injector: "injector" }, decls: 4, vars: 4, consts: [[3, "ngSwitch"], [3, "innerHTML", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngComponentOutlet", "ngComponentOutletInjector"]], template: function DynamicContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, DynamicContentComponent_div_1_Template, 1, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicContentComponent_ng_container_2_Template, 2, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, DynamicContentComponent_ng_container_3_Template, 2, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.contentType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.ContentType.String);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.ContentType.Template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.ContentType.Component);
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgComponentOutlet], styles: ["[_nghost-%COMP%] {\n        display: block;\n      }"], changeDetection: 0 });
DynamicContentComponent.propDecorators = {
    content: [{ type: Input }],
    context: [{ type: Input }],
    injector: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicContentComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-content',
                template: `
    <ng-container [ngSwitch]="contentType">
      <div *ngSwitchCase="ContentType.String" [innerHTML]="content"></div>

      <ng-container *ngSwitchCase="ContentType.Template">
        <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="ContentType.Component">
        <ng-container *ngComponentOutlet="content; injector: injector"></ng-container>
      </ng-container>
    </ng-container>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [`
      :host {
        display: block;
      }
    `]
            }]
    }], function () { return []; }, { content: [{
            type: Input
        }], context: [{
            type: Input
        }], injector: [{
            type: Input
        }] }); })();
class DynamicContentModule {
}
DynamicContentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicContentModule });
DynamicContentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DynamicContentModule_Factory(t) { return new (t || DynamicContentModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicContentModule, { declarations: function () { return [DynamicContentComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DynamicContentComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicContentModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [DynamicContentComponent],
                exports: [DynamicContentComponent]
            }]
    }], null, null); })();

class TemplateOrStringDirective {
    constructor(defaultTpl, vcr) {
        this.defaultTpl = defaultTpl;
        this.vcr = vcr;
    }
    set templateOrStringContext(context) {
        this.context = context;
    }
    ngOnInit() {
        const template = this.content instanceof TemplateRef ? this.content : this.defaultTpl;
        this.vcr.createEmbeddedView(template, this.context);
    }
}
TemplateOrStringDirective.ɵfac = function TemplateOrStringDirective_Factory(t) { return new (t || TemplateOrStringDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
TemplateOrStringDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TemplateOrStringDirective, selectors: [["", "templateOrString", ""]], inputs: { templateOrStringContext: "templateOrStringContext", content: ["templateOrString", "content"] } });
TemplateOrStringDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
TemplateOrStringDirective.propDecorators = {
    templateOrStringContext: [{ type: Input }],
    content: [{ type: Input, args: ['templateOrString',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TemplateOrStringDirective, [{
        type: Directive,
        args: [{
                selector: '[templateOrString]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { templateOrStringContext: [{
            type: Input
        }], content: [{
            type: Input,
            args: ['templateOrString']
        }] }); })();
class TemplateOrStringModule {
}
TemplateOrStringModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TemplateOrStringModule });
TemplateOrStringModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TemplateOrStringModule_Factory(t) { return new (t || TemplateOrStringModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TemplateOrStringModule, { declarations: [TemplateOrStringDirective], exports: [TemplateOrStringDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TemplateOrStringModule, [{
        type: NgModule,
        args: [{
                declarations: [TemplateOrStringDirective],
                exports: [TemplateOrStringDirective]
            }]
    }], null, null); })();

class TeleportService {
    constructor() {
        this.outlets = new BehaviorSubject('');
        this.asObservable = this.outlets.asObservable();
        this.ports = new Map();
    }
    outlet$(name) {
        return this.asObservable.pipe(filter(current => current === name), map(name => this.ports.get(name)));
    }
    newOutlet(name) {
        this.outlets.next(name);
    }
}
TeleportService.ɵfac = function TeleportService_Factory(t) { return new (t || TeleportService)(); };
TeleportService.ɵprov = ɵɵdefineInjectable({ factory: function TeleportService_Factory() { return new TeleportService(); }, token: TeleportService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TeleportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class TeleportOutletDirective {
    constructor(vcr, service) {
        this.vcr = vcr;
        this.service = service;
    }
    ngOnInit() {
        this.service.ports.set(this.teleportOutlet, this.vcr);
        this.service.newOutlet(this.teleportOutlet);
    }
    ngOnDestroy() {
        this.service.ports.delete(this.teleportOutlet);
    }
}
TeleportOutletDirective.ɵfac = function TeleportOutletDirective_Factory(t) { return new (t || TeleportOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(TeleportService)); };
TeleportOutletDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TeleportOutletDirective, selectors: [["", "teleportOutlet", ""]], inputs: { teleportOutlet: "teleportOutlet" } });
TeleportOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TeleportService }
];
TeleportOutletDirective.propDecorators = {
    teleportOutlet: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TeleportOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[teleportOutlet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: TeleportService }]; }, { teleportOutlet: [{
            type: Input
        }] }); })();

class TeleportDirective {
    constructor(tpl, service) {
        this.tpl = tpl;
        this.service = service;
    }
    ngOnInit() {
        this.subscription = this.service.outlet$(this.teleportTo).subscribe((outlet) => {
            if (outlet) {
                this.viewRef = outlet.createEmbeddedView(this.tpl);
            }
        });
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.viewRef) === null || _b === void 0 ? void 0 : _b.destroy();
    }
}
TeleportDirective.ɵfac = function TeleportDirective_Factory(t) { return new (t || TeleportDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(TeleportService)); };
TeleportDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TeleportDirective, selectors: [["", "teleportTo", ""]], inputs: { teleportTo: "teleportTo" } });
TeleportDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: TeleportService }
];
TeleportDirective.propDecorators = {
    teleportTo: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TeleportDirective, [{
        type: Directive,
        args: [{
                selector: '[teleportTo]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: TeleportService }]; }, { teleportTo: [{
            type: Input
        }] }); })();
class TeleportModule {
}
TeleportModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TeleportModule });
TeleportModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TeleportModule_Factory(t) { return new (t || TeleportModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TeleportModule, { declarations: [TeleportDirective, TeleportOutletDirective], exports: [TeleportDirective, TeleportOutletDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TeleportModule, [{
        type: NgModule,
        args: [{
                declarations: [TeleportDirective, TeleportOutletDirective],
                exports: [TeleportDirective, TeleportOutletDirective]
            }]
    }], null, null); })();

class StringRef {
    constructor(value) {
        this.value = value;
    }
    getElement() {
        return this.value;
    }
    detectChanges() { }
    destroy() { }
}

class CompRef {
    constructor(args) {
        this.args = args;
        const factory = this.args.resolver.resolveComponentFactory(this.args.component);
        if (this.args.vcr) {
            this.compRef = this.args.vcr.createComponent(factory, this.args.vcr.length, args.injector || this.args.vcr.injector);
        }
        else {
            this.compRef = factory.create(this.args.injector);
            this.args.appRef.attachView(this.compRef.hostView);
        }
    }
    get ref() {
        return this.compRef;
    }
    setInput(input, value) {
        this.compRef.instance[input] = value;
        return this;
    }
    setInputs(inputs) {
        Object.keys(inputs).forEach((input) => {
            this.compRef.instance[input] = inputs[input];
        });
        return this;
    }
    detectChanges() {
        this.compRef.hostView.detectChanges();
        return this;
    }
    appendTo(container) {
        container.appendChild(this.getElement());
        return this;
    }
    removeFrom(container) {
        container.removeChild(this.getElement());
        return this;
    }
    getRawContent() {
        return this.getElement().outerHTML;
    }
    getElement() {
        return this.compRef.location.nativeElement;
    }
    destroy() {
        this.compRef.destroy();
        !this.args.vcr && this.args.appRef.detachView(this.compRef.hostView);
        this.compRef = null;
    }
}

class TplRef {
    constructor(args) {
        this.args = args;
        this.wrapper = null;
        if (this.args.vcr) {
            this.viewRef = this.args.vcr.createEmbeddedView(this.args.tpl, this.args.context || {});
            this.viewRef.detectChanges();
        }
        else {
            this.viewRef = this.args.tpl.createEmbeddedView(this.args.context || {});
            this.viewRef.detectChanges();
            this.args.appRef.attachView(this.viewRef);
        }
    }
    detectChanges() {
        this.viewRef.detectChanges();
    }
    getElement() {
        const rootNodes = this.viewRef.rootNodes;
        if (rootNodes.length === 1 && rootNodes[0] === Node.ELEMENT_NODE) {
            this.element = rootNodes[0];
        }
        else {
            this.element = document.createElement('div');
            this.element.append(...rootNodes);
        }
        return this.element;
    }
    destroy() {
        if (this.viewRef.rootNodes[0] !== 1) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        }
        if (!this.args.vcr) {
            this.args.appRef.detachView(this.viewRef);
        }
        this.viewRef.destroy();
        this.viewRef = null;
    }
}

function isTemplateRef(value) {
    return value instanceof TemplateRef;
}
function isComponent(value) {
    return typeof value === 'function';
}
function isString(value) {
    return typeof value === 'string';
}

class ViewService {
    constructor(resolver, injector, appRef) {
        this.resolver = resolver;
        this.injector = injector;
        this.appRef = appRef;
    }
    createComponent(component, options = {}) {
        return new CompRef({
            component,
            vcr: options.vcr,
            injector: options.injector || this.injector,
            appRef: this.appRef,
            resolver: this.resolver,
        });
    }
    createTemplate(tpl, options = {}) {
        return new TplRef({
            vcr: options.vcr,
            appRef: this.appRef,
            tpl,
            context: options.context,
        });
    }
    createView(content, viewOptions = {}) {
        if (isTemplateRef(content)) {
            return this.createTemplate(content, viewOptions);
        }
        else if (isComponent(content)) {
            return this.createComponent(content, viewOptions);
        }
        else if (isString(content)) {
            return new StringRef(content);
        }
        else {
            throw 'Type of content is not supported';
        }
    }
}
ViewService.ɵfac = function ViewService_Factory(t) { return new (t || ViewService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef)); };
ViewService.ɵprov = ɵɵdefineInjectable({ factory: function ViewService_Factory() { return new ViewService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR), ɵɵinject(ApplicationRef)); }, token: ViewService, providedIn: "root" });
ViewService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: ApplicationRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ViewService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ApplicationRef }]; }, null); })();

/*
 * Public API Surface of overview
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CompRef, DynamicContentModule, StringRef, TeleportModule, TemplateOrStringModule, TplRef, ViewService, isComponent, isString, isTemplateRef, DynamicContentComponent as ɵa, TemplateOrStringDirective as ɵb, TeleportDirective as ɵc, TeleportService as ɵd, TeleportOutletDirective as ɵe };

//# sourceMappingURL=ngneat-overview.js.map